import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSessionContext } from '../contexts/SessionContext';

const PE_API = process.env.NX_PE_API;

const CONTEXT = 'geobuffer';
const ACCOUNTS_URL = process.env.NX_ACCOUNTS_URL;
const SSO_REDIRECT = `${PE_API}/public/auth/sso-redirect?timestamp=${new Date().getTime()}`;
const LOGIN_URL = `${ACCOUNTS_URL}/login?context=${CONTEXT}&redirect=${encodeURI(SSO_REDIRECT)}`;

const LoginExt: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { setJwtToken } = useSessionContext();
  const jwt = searchParams.get('t');

  useEffect(() => {
    if (jwt) {
      setJwtToken(jwt);
    }
  }, [jwt]);

  if (!jwt) {
    window.location.href = LOGIN_URL;
  }

  return null;
};

export default LoginExt;
